import { useDebugValue, useEffect, useState } from 'react';

import ajaxClient from '../../../../utils/ajaxClient';
import { isUserLoggedIn } from '../../../../helpers/userMetadataHelper';
import {
  MENU_ITEM__FORMS__ASSIGNED,
  MENU_ITEM__FORMS__DRAFT,
  MENU_ITEM__FORMS__RETURNED,
  MENU_ITEM__FORMS__SENT,
  MENU_ITEM__FORMS__APPROVED,
} from '../../../constants';
import { interceptErrorMessage } from '../../../../shared/helpers/apiErrorsInterceptor';

const useGetQuestionnaires = (selectedMenuItem = MENU_ITEM__FORMS__ASSIGNED, selectedElement, onError, refreshQuestionariesTimeStamp) => {
  useDebugValue('useGetQuestionnaires');

  const [isFetching, setIsFetching] = useState(true);
  const [questionnaires, setQuestionnaires] = useState([]);

  const urlResolver = (menuItem) => {
    if (isUserLoggedIn()) {
      switch (menuItem) {
        case MENU_ITEM__FORMS__ASSIGNED:
          return 'Forms/Assigned';
        case MENU_ITEM__FORMS__RETURNED:
          return 'Forms/Returned';
        case MENU_ITEM__FORMS__DRAFT:
          return 'Forms/Draft';
        case MENU_ITEM__FORMS__SENT:
          return 'Forms/Sent';
        case MENU_ITEM__FORMS__APPROVED:
          return 'Forms/Approved';
        default:
          return 'Forms/Assigned';
      }
    }

    return 'questionnaires';
  };

  const fetchQuestionnaires = (menuItem) => {
    setIsFetching(true);
    const url = urlResolver(menuItem);

    return ajaxClient
      .getRequest(url, null)
      .then((response) => {
        if (response) {
          setQuestionnaires(response.data);
          setIsFetching(false);
        }
      })
      .catch((exception) => {
        if (exception) {
          if (onError) {
            onError(interceptErrorMessage(exception));
          }

          setIsFetching(false);
        }
      });
  };

  useEffect(() => {
    if (selectedMenuItem) {
      fetchQuestionnaires(selectedMenuItem);
    }
  }, [selectedMenuItem, selectedElement]);

  useEffect(() => {
    if (selectedMenuItem) {
      fetchQuestionnaires(selectedMenuItem);
    }
  }, [refreshQuestionariesTimeStamp]);

  return { isQuestionnairesFetching: isFetching, questionnaires };
};

export default useGetQuestionnaires;
